import type { ReactNode } from 'react';

import { Toaster } from '@nesso/ui/primitives/sonner';
import { TooltipProvider } from '@nesso/ui/primitives/tooltip';
import { InactivityTimerProvider } from '@nesso/ui/providers/inactivity-timer-provider';
import { ReactQueryDevtoolsToggle } from '@nesso/ui/providers/react-query-devtools-toggle';
import { ThemeProvider } from '@nesso/ui/providers/theme-provider';

import { InactivitySignOutProvider } from '@/app/providers/inactivity-sign-out-provider';
import { QueryProvider } from '@/app/providers/query-provider';

type Props = {
    children: ReactNode;
};

export function AppProviders({ children }: Props) {
    return (
        <QueryProvider>
            <InactivityTimerProvider>
                <ThemeProvider attribute="class" defaultTheme="light" disableTransitionOnChange>
                    <TooltipProvider>
                        {/* Before children: sonner drops any toast published while it has no
                            subscriber, and a route can toast from a mount effect. */}
                        <Toaster />
                        {children}
                        <InactivitySignOutProvider />
                        <ReactQueryDevtoolsToggle appEnv={import.meta.env.VITE_APP_ENV} />
                    </TooltipProvider>
                </ThemeProvider>
            </InactivityTimerProvider>
        </QueryProvider>
    );
}
